import styled, { css } from 'styled-components';
import mediaQuery from '../../../../helpers/mediaQuery';
import spacing, { spacingWithBorder } from '../../../../helpers/spacing';
import PredefinedPanel from '../../../Panel/PredefinedPanel';
import { PanelOptions } from '../../../Panel/PredefinedPanel/predefinedStyles';

export const ContentSpacing = styled.div<{ showPanel: boolean }>`
  transition: margin 0.3s ease-out, width 0.3s ease-out;

  ${mediaQuery.tabletPortrait`
    width: 100%;
  `}

  ${({ showPanel }) =>
    showPanel &&
    css`
      margin: ${spacing(1)} ${spacingWithBorder(2, 1)} ${spacingWithBorder(3, 1)}
        ${spacingWithBorder(2, 1)};
      ${mediaQuery.tabletPortrait`
        margin-top: ${spacingWithBorder(3, 1)};
        /* this width ensures that the input box stays inside the error container and isn't too close to the corner label */
        width: calc(100% - ${spacing(4)})
      `}
      ${mediaQuery.tabletLandscape`
        margin: ${spacingWithBorder(3, 1)} ${spacingWithBorder(3, 1)} 
        ${spacingWithBorder(4, 1)} ${spacingWithBorder(3, 1)};
        /* this width ensures that the input box stays inside the error container and isn't too close to the corner label */
        width: calc(100% - ${spacing(12)})
      `}
    `}
`;

export const StyledPredefinedPanel = styled(PredefinedPanel)`
  /* Reset relevant styles when rendered as a fieldset */
  padding: 0;
  margin: 0 0 ${spacingWithBorder(3, 1)};
  transition: padding 0.3s ease-out;

  ${mediaQuery.tabletLandscape`
    margin-bottom: ${spacingWithBorder(4, 1)};
  `}

  && {
    border: none;
    ${({ panelType }) =>
      panelType !== PanelOptions.NONE &&
      css`
        margin: 0 0 ${spacing(2)};
        padding: 0;
        ${mediaQuery.tabletLandscape`
          margin-bottom: ${spacing(3)};
        `};
      `}
  }
`;
